// lib
import { styled } from '@nykaa/ui-components';

//components
import ImageV2 from 'shared/components/ImageV2';
import { FOCUS_VISIBILITY_CSS } from 'shared/styles/base';

export const Container = styled.div`
  width: 100%;
  padding: ${({ theme }) => `${theme.spacing.spacing80} 0 0 0`};
`;

export const Title = styled.div`
  height: 12px;
  line-height: 12px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  ${({ theme }) => theme.typography.subTitleSmall};
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const LinkContainer = styled.div`
  padding-top: ${({ theme }) => theme.spacing.spacing40};
  display: flex;
  flex-wrap: wrap;
`;

export const Link = styled.a`
  border-radius: ${({ theme }) => theme.borders.radius10};
  &:first-child {
    margin-right: ${({ theme }) => theme.spacing.spacing40};
  }
  ${FOCUS_VISIBILITY_CSS}
`;

export const DownloadImage = styled(ImageV2)`
  width: 42vw;
`;
